// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__YhBhy","chapter":"style__chapter__xWdn7","marker":"style__marker__ziXZd","withChapters":"style__withChapters__NX+E8"};